<template>
  <v-container class="featured-section">
    <v-layout align-center class="section-padding clickable" @click="openNavigationPage()">
      <div class="icon__background flex-none">
        <v-img v-if="iconURL" height="24" width="24" :src="iconURL" contain></v-img>
        <v-icon v-else color="primary lighten-1">{{ icon }}</v-icon>
      </div>
      <v-flex class="text-color__dark H3 px-2">{{title}}</v-flex>
      <v-chip small class="page-chip white" color="primary lighten-1">
        <span>{{ page.pageSpecific.relatedPages.length }}</span>
        <v-icon small class="material-symbols-rounded ml-2">arrow_forward</v-icon>
      </v-chip>
    </v-layout>
    <div class="featured-page__container py-2">
      <page-in-navigation
        v-for="relatedPage in page.pageSpecific.relatedPages"
        :key="relatedPage.page.id"
        :page="relatedPage.page"
        :insideFeatured="true"
        class="ma-2"
      ></page-in-navigation>
    </div>
  </v-container>
</template>

<script>
import router from '@/router'
import routeNames from '@/router/routes'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { mapGetters } from 'vuex'
import { cardAppearanceTypes } from '@/config'

export default {
  props: {
    page: Object,
  },
  data () {
    return {
      cardAppearanceTypes,
    }
  },
  methods: {
    openNavigationPage () {
      this.$store.commit('pages/setPage', this.page)
      router.push({ name: routeNames.page_details.name, params: { pageId: this.page.id }})
    },
  },
  computed: {
    ...mapGetters({ 
      authStatus: 'auth/authStatus',
      cardAppearance: 'service/getCardAppearance',
      authToken: 'auth/authToken',
    }),
    icon () {
      let icon = null
      if (this.page) {
        icon = this.page.icon
      }
      if (!icon) {
        icon = 'mdi-menu'
      }
      return icon
    },
    iconURL () {
      let icon = null
      if (this.page) {
        icon = this.page.iconUrl
      }
      return icon
    },
    title () {
      let title = null
      if (this.page) {
        title = getTextValue(this.page.pageSpecific.title)
      }
      return title
    },
  },
  components: {
    PageInNavigation: () => import('@/components/view-components/webapp-pages/PageInNavigation.vue'),
  },
}
</script>